import { components } from '../api-abcscale';
import { apiGet, ApiCallbacks } from '../apiClient';

type SkuPermissionsDto = components['schemas']['SkuPermissionsDto'];

const ADMIN_API_BASE = process.env.REACT_APP_ADMIN_API_BASE;

export async function getSkuEntitlements(
  callbacks: ApiCallbacks<SkuPermissionsDto>
): Promise<void> {
  await apiGet(`${ADMIN_API_BASE}/entitlements/sku`, callbacks, true);
}
